// Barra de filtros da listagem: só status. O white label vem do seletor GLOBAL
// do menu (useAuth.selectedWhiteLabel) — combo de loja aqui seria um segundo
// lugar para escolher a mesma coisa. O valor mora na URL; aqui só recebe e emite.
import { XIcon } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { cn } from "@/lib/utils"

import type { StatusFilterValue } from "../constants"

const prefix = "pages.paymentConfigurations"

interface PaymentConfigurationsFiltersProps {
  status: StatusFilterValue
  hasActiveFilters: boolean
  onStatusChange: (status: StatusFilterValue) => void
  onClear: () => void
  className?: string
}

const isStatusFilterValue = (
  value: string
): value is StatusFilterValue =>
  value === "all" || value === "true" || value === "false"

export const PaymentConfigurationsFilters = ({
  status,
  hasActiveFilters,
  onStatusChange,
  onClear,
  className,
}: PaymentConfigurationsFiltersProps) => {
  const { t } = useTranslation()

  return (
    <div
      className={cn(
        "flex flex-wrap items-end gap-3 rounded-xl border bg-card px-4 py-3 shadow-sm",
        className
      )}
    >
      <div className="flex min-w-[160px] flex-col gap-1.5">
        <Label htmlFor="payment-configurations-status">
          {t(`${prefix}.filters.status`)}
        </Label>
        <Select
          value={status}
          onValueChange={(value) => {
            if (isStatusFilterValue(value)) {
              onStatusChange(value)
            }
          }}
        >
          <SelectTrigger
            id="payment-configurations-status"
            className="h-9"
          >
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">
              {t(`${prefix}.filters.allStatuses`)}
            </SelectItem>
            <SelectItem value="true">
              {t(`${prefix}.status.active`)}
            </SelectItem>
            <SelectItem value="false">
              {t(`${prefix}.status.inactive`)}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
      {hasActiveFilters && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-9 gap-1.5 text-muted-foreground"
          onClick={onClear}
        >
          <XIcon
            className="h-3.5 w-3.5"
            aria-hidden="true"
          />
          {t(`${prefix}.filters.clear`)}
        </Button>
      )}
    </div>
  )
}
